import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { baseurl, payuredircturl, payuurl } from '../../utility/helper';


function HiddenPayuForm({ testId }) {
    const productinfo = testId // this get Test-11
    const productType = productinfo.includes("-") // this get Test
        ? productinfo.split("-")[0]
        : productinfo;  


    const [formData, setFormData] = useState({
        candidateId: "",
        mobile: "",
        firstname: "",
        lastname: "",
        email: "",
        testId: "",
        txnid: "",
        amount: "",
        key: "",
        hash: ""

    })

    const [paymentData, setPaymentData] = useState(null);
    const [error, setError] = useState(null);

    const fetchFees = async () => {
        try {
            const response = await axios.get(`${baseurl}/admin/getFees`);
            const fees = response.data;

            const isNewMember = productinfo.includes("-new");
            const isRestart = productinfo.includes("-restart");   // NEW

            // Base product type (remove suffix)
            let productType = productinfo
                .replace("-new", "")
                .replace("-restart", "")
                .replace(/-\d+$/, "");

            // Find base fee (Annual / 5Years / Life)
            const feeRecord = fees.find(fee => fee.type === productType);

            if (!feeRecord) {
                alert("Fee not found for product: " + productType);
                return;
            }

            let totalFees = Number(feeRecord.fees);

            // Add Joining Fees (NEW MEMBER)
            if (isNewMember) {
                const joiningRecord = fees.find(fee => fee.type === "Joiningfees");
                if (joiningRecord) {
                    totalFees += Number(joiningRecord.fees);
                    console.log(`Base: ${feeRecord.fees}, Joining: ${joiningRecord.fees}`);
                } else {
                    console.warn("Joining fee record not found");
                }
            }

            // Add Reinstatement Fees (RESTART)
            if (isRestart) {
                const restartRecord = fees.find(fee => fee.type === "Reinstatementfees");
                if (restartRecord) {
                    totalFees += Number(restartRecord.fees);
                    console.log(`Base: ${feeRecord.fees}, Restart: ${restartRecord.fees}`);
                } else {
                    console.warn("Reinstatement fee record not found");
                }
            }

            console.log("Final Total:", totalFees);

            setFormData(prev => ({
                ...prev,
                amount: totalFees,
            }));

            setPaymentData({ ...feeRecord, fees: totalFees });

        } catch (error) {
            console.error("Error fetching fees:", error);
            alert("Failed to fetch fees.");
        }
    };

    useEffect(() => {
        fetchFees()
    }, [])


    useEffect(() => {
        console.log("i am 1")
        const userId = parseInt(sessionStorage.getItem("CandidateID")) || parseInt(sessionStorage.getItem("MemberID"));
        let Canlevel = null;
        const storedLevel = sessionStorage.getItem("PreTestDataLevel");
        if (storedLevel) {
            try {
                const parsed = JSON.parse(storedLevel); // { education: "Low" }
                Canlevel = parsed.education; // "Low"
            } catch (e) {
                console.error("Error parsing PreTestDataLevel:", e);
            }
        }
        if (!userId) {
            alert("Candidate ID not found. Please log in again.");
            return;
        } else {
            setFormData(prev => ({
                ...prev,
                candidateId: userId
            }))
        }
        if (!userId || !formData.amount || !productType) return;

        // const fetchPaymentDetails = () => {
        //     axios.get(
        //         `${baseurl}/candidate/payment/${userId}`, {
        //         params: { amout: amount, product: testId}
        //     }
        //     )
        //         .then(response => {
        //             const data = response.data;
        //             console.log(data);

        //             setFormData(prev => ({
        //                 ...prev,
        //                 mobile: data.candidate.mobile_no,
        //                 firstname: data.candidate.first_name,
        //                 lastname: data.candidate.last_name,
        //                 email: data.candidate.email,
        //                 testId: testId,
        //                 txnid: data.candidate.txnid,
        //                 amount: amount,
        //                 key: data.candidate.key,
        //                 hash: data.candidate.hash
        //             }));
        //         })
        //         .catch(error => {
        //             // Axios errors have response and message
        //             if (error.response) {
        //                 setError(`Error: ${error.response.status} - ${error.response.data}`);
        //             } else {
        //                 setError(error.message);
        //             }
        //         });
        // };
        const fetchPaymentDetails = () => {
            const candidateId = parseInt(sessionStorage.getItem("CandidateID"));
            const memberId = parseInt(sessionStorage.getItem("MemberID"));

            const userId = candidateId || memberId; // Pick whichever is non-null first
            const isCandidate = !!candidateId;

            if (!userId) {
                setError("No CandidateID or MemberID found in session.");
                return;
            }

            const userType = isCandidate ? "candidate" : "member";

            axios
                .get(`${baseurl}/${userType}/payment/${userId}`, {
                    params: { amout: formData.amount, product: productinfo } // Typo? Should be `amount`
                })
                .then(response => {
                    const data = response.data;
                    const userData = isCandidate ? data.candidate : data.member;

                    console.log("Payment data:", data);

                    setFormData(prev => ({
                        ...prev,
                        mobile: userData.mobile_no,
                        firstname: userData.first_name,
                        lastname: userData.last_name,
                        email: userData.email,
                        testId: productinfo,
                        txnid: userData.txnid,
                        amount: userData.amount ?? prev.amount,
                        key: userData.key,
                        hash: userData.hash
                    }));
                })
                .catch(error => {
                    if (error.response) {
                        setError(`Error: ${error.response.status} - ${error.response.data}`);
                    } else {
                        setError(error.message);
                    }
                });
        };



        fetchPaymentDetails();
    }, [formData.amount, productType]);


    return (
        <div>
            <form action={payuurl} id="payment_form" method="Post">
                <input
                    // type="text"
                    type="hidden"
                    id="txnid"
                    name="txnid"
                    placeholder="Transaction ID"
                    value={formData.txnid}
                    className="form-control item"
                    readOnly
                />
                <input
                    // type="text"
                    type="hidden"
                    id="amount"
                    name="amount"
                    placeholder="Amount"
                    value={formData.amount}
                    className="form-control item"
                />
                <input
                    // type="text"
                    type="hidden"
                    id="productinfo"
                    name="productinfo"
                    placeholder="Product Info"
                    value={productinfo}
                    className="form-control item"
                />
                <input type="hidden" id="productlevel" name="productlevel" value={formData.canlevel} />
                <input
                    // type="text"
                    type="hidden"
                    id="firstname"
                    name="firstname"
                    placeholder="First Name"
                    value={formData.firstname}
                    className="form-control item"
                />
                <input
                    // type="text"
                    type="hidden"
                    id="Lastname"
                    name="Lastname"
                    placeholder="Last Name"
                    value={formData.lastname}
                    className="form-control item"
                />

                <input
                    // type="text"
                    type="hidden"
                    id="email"
                    name="email"
                    placeholder="Email ID"
                    value={formData.email}
                    className="form-control item"
                />
                <input
                    // type="text"
                    type="hidden"
                    id="phone"
                    name="phone"
                    placeholder="Mobile/Cell Number"
                    value={formData.mobile}
                    className="form-control item"
                />
                <input
                    // type="text"
                    type="hidden"
                    id="hash"
                    name="hash"
                    placeholder="Hash"
                    value={formData.hash}
                    className="form-control item"
                    readOnly
                />

                <input type="hidden" id="udf5" name="udf5" value={formData.candidateId} />


                <input
                    type="submit"
                    className="btn btn-block create-account"
                    value="Proceed for Payment"
                    style={{ marginTop: "20px", backgroundColor: "#000C80", color: "white" }}
                />
                < input type="hidden" id="surl" name="surl" value={payuredircturl} />
                <input type="hidden" id="furl" name="furl" value={payuredircturl} />
                <input type="hidden" id="curl" name="curl" value={payuredircturl} />
                <input type="hidden" id="key" name="key" value={formData.key} />



            </form >
        </div >
    )
}

export default HiddenPayuForm